import "./App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import Home from "./Pages/Home";
import RecoveryPassword from "./Pages/RecoveryPassword";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import DeleteAccountRequest from "./Pages/DeleteAccountRequest";
import React, { useEffect } from "react";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    let result = getQueryVariable("page");

    if (result === "recovery") {
      let vcode = getQueryVariable("vcode");
      let id = getQueryVariable("id");
      navigate('/recovery', { state: { vcode: vcode , id: id } });
    } else if(result === "privacypolicy") {
      navigate('/privacypolicy');
    } else if(result === "deleteaccountrequest") {
      navigate('/deleteaccountrequest');
    } 

  }, [navigate]);

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    //  console.log(query)//"app=article&act=news_content&aid=160990"
    var vars = query.split("&");
    // console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
     // console.log(pair); //[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ]
      if (pair[0] === variable) {
        return pair[1];
      }
    }
    return false;
  }

  return (
    <div className="App">
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/recovery" element={<RecoveryPassword />} />
        <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route exact path="/deleteaccountrequest" element={<DeleteAccountRequest />} />
      </Routes>
    </div>
  );
}

export default App;
